import createHintComponent from "../../../../helpers/common/CoreInputText/components/Hint/fabric";
import { INPUT_TEXTAREA_DISPLAY_NAME } from "../../utils/core";

export const Component = createHintComponent(INPUT_TEXTAREA_DISPLAY_NAME);
export default Component;
